// @flow
import React from 'react';
import { Slider } from 'components/atoms/slider';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  min: number,
  max: number,
  values?: Array<number>,
  onChange: (value: number) => void,
};

export const BedsFilter = (props: Props) => {
  const { min, max, values, onChange } = props;

  return (
    <div className={'beds-filter filter inline'}>
      <h5 className={'filter-title'}>Beds</h5>
      <div className={'filter-options'}>
        <Slider
          type={'slider'}
          min={min}
          max={max}
          onChange={onChange}
          values={values}
          showTooltip={true}
          tooltipFormatter={v => `${v}+`}
        />
      </div>
    </div>
  );
};
